jQuery(document).ready(function($) {


    /** =============================================================== **/
    /** Accessibility Improvements **/
    /** =============================================================== **/

    // Determine accessibility focus based on mouse/keyboard use
    document.body.addEventListener('mousedown', function() {
        document.body.classList.add('using-mouse');
    });
    document.body.addEventListener('keydown', function() {
        document.body.classList.remove('using-mouse');
    });


    /** =============================================================== **/
    /** Init Input masks **/
    /** =============================================================== **/

    $(".phone-mask").inputmask({
        "mask": "(999) 999-9999"
    });

    $(".date-mask").inputmask({
        alias: "mm/dd/yyyy",
        clearIncomplete: true,
        yearrange: {
            minyear: 1900,
            maxyear: 2000
        }
    });

    $(".zip-mask").inputmask({
        "mask": "99999",
        "placeholder": "",
    });


    /** =============================================================== **/
    /** Handle sticky menu on scroll **/
    /** =============================================================== **/

    $(window).on("scroll", function() {
        $("header").toggleClass("pin", $(window).scrollTop() >= 50);
    });
    $(window).trigger("scroll");

    /** =============================================================== **/
    /** Modal in modal opening fix **/
    /** =============================================================== **/

    $('.modal').on("hidden.bs.modal", function (e) { 
        if ($('.modal:visible').length) { 
            $('body').addClass('modal-open');
        }
    });

    /** =============================================================== **/
    /** Menu toogler on mobile hamburger class change **/
    /** =============================================================== **/

    $(".hamburger").on("click", function(e) {
        e.preventDefault();
        $(this).toggleClass("is-active");
        $('body').toggleClass("overflow-hidden");
    });


    /** =============================================================== **/
    /** Simplre select placeholder **/
    /** =============================================================== **/

    $(".form-select").change(function() {
        $(this).addClass('selected');
    });


    /** =============================================================== **/
    /** Plans mobile text change upon collapse **/
    /** =============================================================== **/

    $(".plan-box-single .collapse-link").click(function() {
        $(this).text(($(this).text() == 'View Plan Details') ? 'Hide Plan Details' : 'View Plan Details')
    });


    /** =============================================================== **/
    /** Scroll to id **/
    /** =============================================================== **/

    $(".scrollto").click(function(event) {
        event.preventDefault(); 

        var defaultAnchorOffset = 70;

        var anchor = $(this).attr('target');
                
        var anchorOffset = $('#'+anchor).attr('data-scroll-offset');
        if (!anchorOffset)
            anchorOffset = defaultAnchorOffset; 

        $('html,body').animate({ 
            scrollTop: $('#'+anchor).offset().top - anchorOffset
        }, 200);        
    });


    /** =============================================================== **/
    /** Slick slider **/
    /** =============================================================== **/

    if ($(".logos-slider").length) {
        $(".logos-slider").slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 1000,
            slidesToShow: 4,
            slidesToScroll: 4,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 575.98,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
        });
    };

    /** =============================================================== **/
    /** Contact form 7 add class to checkbox **/
    /** =============================================================== **/

    $('input:checkbox').addClass('form-check-input');

});


/** =============================================================== **/
/** tooltip init **/
/** =============================================================== **/

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
});
